import LOGO from "../images/Abejas.png";

export const Team__Abejas = {
  name: "Abejas",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#FACC15",
  teamJerseyColor: "#111111",

  // Stats
  gamesWon: 3,
  gamesLost: 1,
  gamesTied: 0,
  gamesTiedWon: 0,

  // ownGoalsInFavor: 61 + 21 + 54 + 52,
  // goalsScoredAgainst: 22 + 24 + 29 + 30,
  ownGoalsInFavor: 21 + 52,
  goalsScoredAgainst: 24 + 30,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [],
};
